<template>
  <article class="lt-card">
    <div class="lt-card__cover" :style="coverStyle">
      <img v-if="item.cover" :src="item.cover" class="lt-card__cover-img" :alt="item.name" />
      <div v-else class="lt-card__cover-art">{{ coverInitial }}</div>
      <div class="lt-card__chip-row">
        <span class="lt-card__type-chip">
          <LtIcon :name="typeMeta.icon" :size="13" />
          {{ typeLabel }}
        </span>
      </div>
      <div class="lt-card__chip-row lt-card__chip-row--end">
        <span class="badge" :class="'badge--' + statusMeta.klass">
          <span class="dot"></span>{{ statusMeta.label }}
        </span>
      </div>
    </div>
    <div class="lt-card__body">
      <h3 class="lt-card__title">{{ item.name }}</h3>
      <div class="lt-card__meta">
        <span>{{ item.artist }}</span>
        <span class="dot"></span>
        <span v-if="paymentChip" class="badge" :class="'badge--' + paymentChip.klass" style="height:22px; font-size:11.5px">
          {{ paymentChip.label }}
        </span>
        <span v-else-if="item.status === 'draft'" class="muted">לא שולם</span>
      </div>
      <div class="lt-card__tracks">
        <span>רצועות</span>
        <span class="lt-card__tracks-bar"><i :style="{ width: trackPct + '%' }"></i></span>
        <strong>{{ item.tracks }}/{{ typeMeta.trackLimit }}</strong>
      </div>
    </div>
    <div class="lt-card__foot">
      <button
        type="button"
        class="btn btn--sm"
        :class="primaryAction.style === 'primary' ? 'btn--primary' : 'btn--ghost'"
        @click="$emit('open', { item, intent: primaryAction.intent })"
      >
        {{ primaryAction.label }}
      </button>
      <button
        type="button"
        class="btn btn--sm btn--ghost"
        @click="$emit('open', { item, intent: secondaryAction.intent })"
      >
        {{ secondaryAction.label }}
      </button>
      <button
        v-if="item.status === 'draft' && item.editable"
        type="button"
        class="btn btn--sm btn--ghost lt-card__delete"
        @click="$emit('delete', item)"
      >
        <LtIcon name="trash" :size="14" />
      </button>
    </div>
  </article>
</template>

<script>
import LtIcon from './LtIcon.vue';
import { LINKTONE_TYPES, STATUS_META } from './data.js';

export default {
  name: 'LinktoneCard',
  components: { LtIcon },
  props: {
    item: { type: Object, required: true },
    balanceFor: { type: Function, required: true },
  },
  emits: ['open', 'delete'],
  computed: {
    typeMeta() {
      return LINKTONE_TYPES[this.item.type];
    },
    typeLabel() {
      return this.typeMeta.name.replace('לינקטון ', '');
    },
    statusMeta() {
      return STATUS_META[this.item.status] || STATUS_META.draft;
    },
    trackPct() {
      const lim = this.typeMeta.trackLimit || 1;
      return Math.min(100, Math.round((this.item.tracks / lim) * 100));
    },
    canUseBalance() {
      return this.balanceFor(this.item.type) > 0;
    },
    primaryAction() {
      switch (this.item.status) {
        case 'draft':
          return { label: 'המשך עריכה', intent: 'edit', style: 'primary' };
        case 'ready':
          return this.canUseBalance
            ? { label: 'השתמש ביתרה ושלח', intent: 'submit-balance', style: 'primary' }
            : { label: 'שלם ושלח לאישור', intent: 'submit-pay', style: 'primary' };
        case 'pay':
          return { label: 'תשלום ושליחה', intent: 'submit-pay', style: 'primary' };
        case 'review':
          return { label: 'תצוגה מקדימה', intent: 'preview', style: 'ghost' };
        case 'published':
          return { label: 'תצוגה', intent: 'preview', style: 'ghost' };
        default:
          return { label: 'המשך עריכה', intent: 'edit', style: 'primary' };
      }
    },
    secondaryAction() {
      if (this.item.status === 'review' || this.item.status === 'published') {
        return { label: 'עריכה', intent: 'edit' };
      }
      return { label: 'תצוגה מקדימה', intent: 'preview' };
    },
    coverInitial() {
      return (this.item.name || '?').trim().charAt(0);
    },
    coverStyle() {
      const seeds = [
        'linear-gradient(135deg, #FFB3D1 0%, #FF7AB6 40%, #C58CFF 100%)',
        'linear-gradient(140deg, #FFE3A6 0%, #FF9DBA 60%, #B388FF 100%)',
        'linear-gradient(135deg, #A6E1FF 0%, #C589FF 50%, #FF7AB6 100%)',
        'linear-gradient(160deg, #FFC8A8 0%, #FF7AB6 60%, #7B5BF3 100%)',
        'linear-gradient(140deg, #B5F0CF 0%, #6FD2E5 50%, #C589FF 100%)',
      ];
      const idx = (this.item.id || 0) % seeds.length;
      return { background: seeds[idx] };
    },
    paymentChip() {
      if (this.item.paymentMode === 'balance') return { label: 'מנוצל מהיתרה', klass: 'balance' };
      if (this.item.paymentMode === 'paid') return { label: 'שולם', klass: 'published' };
      if (this.item.paymentMode === 'none' && this.item.status === 'draft') return null;
      return null;
    },
  },
};
</script>
